import { SearchParamField } from "@synota-io/synota-shared-ui";
import { DashboardContractSearchOption } from "../../../../shared/form/DashboardContractSearchField";
import { useServiceChargeContracts } from "../../../../api/hooks/useServiceChargeContracts";

export const useSearchParamsDashboardContract = ({
  uuid,
}: {
  uuid?: string;
}): SearchParamField<DashboardContractSearchOption> => {
  const { contracts } = useServiceChargeContracts({ user_uuid: uuid || "" });

  return {
    deserialize(value) {
      const contract = contracts?.find((contract) => contract.shared_uuid === value);
      if (!contract) {
        return null;
      }
      return { ...contract, label: contract.name, value: contract.shared_uuid };
    },
    serialize(value) {
      return value?.value || "";
    },
  };
};
